'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = require('underscore');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ColoringRecord = require('conversations-schema/records/ColoringRecord');

var _ColoringRecord2 = _interopRequireDefault(_ColoringRecord);

var _RoleTypes = require('conversations-schema/constants/RoleTypes');

var _RoleTypes2 = _interopRequireDefault(_RoleTypes);

var _ChatBubble = require('ui-addon-conversations/components/ChatBubble');

var _ChatBubble2 = _interopRequireDefault(_ChatBubble);

var _UILoading = require('UIComponents/loading/UILoading');

var _UILoading2 = _interopRequireDefault(_UILoading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TypingIndicator(_ref) {
  var currentRole = _ref.currentRole,
      messageRole = _ref.messageRole,
      coloring = _ref.coloring;

  var loadingColor = coloring && !coloring.useDefault ? coloring.accentColor : undefined;

  return _react2.default.createElement(
    'div',
    { className: 'chat-message m-top-2' },
    _react2.default.createElement(
      _ChatBubble2.default,
      {
        className: 'p-x-3 typing-indicator',
        currentRole: currentRole,
        messageRole: messageRole,
        isFirstInGroup: true,
        isLastInGroup: true,
        coloring: coloring,
        isMostRecentMessage: false
      },
      _react2.default.createElement(_UILoading2.default, { color: loadingColor, grow: false })
    )
  );
}

TypingIndicator.propTypes = {
  currentRole: _react.PropTypes.oneOf((0, _underscore.values)(_RoleTypes2.default)).isRequired,
  messageRole: _react.PropTypes.oneOf((0, _underscore.values)(_RoleTypes2.default)).isRequired,
  coloring: _react.PropTypes.instanceOf(_ColoringRecord2.default)
};

exports.default = TypingIndicator;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.133/js/components/TypingIndicator.js
// module id = 405
// module chunks = 0 1